/* @flow */
import * as React from 'react';
import Text from 'components/Text.jsx';
import Tooltip from 'components/Tooltip.jsx';
import TooltipTrigger from 'components/TooltipTrigger.jsx';

import './styles/TextWithTooltip.scss';

/**
 * ## Add a [Tooltip](/internal/components/Tooltip) to inline [Text](/internal/components/Text).
 *
 *
 * ```example
 * <Text>
 *   Lorem
 *   {' '}
 *   <TextWithTooltip tooltip="Total number of announcements and chats">
 *     ipsum dolor
 *   </TextWithTooltip>
 *   {' '}
 *   sit amet.
 * </Text>
 * ```
 */

type Props = {
  // flow chokes on non-optional children
  children?: React.Node,
  tooltip: string,
  tooltipPlacement?: 'top' | 'right' | 'bottom' | 'left',
};

function TextWithTooltip(props: Props) {
  const { children, tooltip, tooltipPlacement = 'top', ...others } = props;

  return (
    <TooltipTrigger placement={tooltipPlacement} tooltip={<Tooltip>{tooltip}</Tooltip>}>
      <span>
        <Text {...others} decoration="dashes">
          {children}
        </Text>
      </span>
    </TooltipTrigger>
  );
}

export default TextWithTooltip;
